import { cn } from '@seen/ui'
import type { JSX, ReactNode, RefObject } from 'react'
import { ScrollArea } from '#src/components/core/scroll-area/ScrollArea.tsx'
import { ScrollAreaContent } from '#src/components/core/scroll-area/ScrollAreaContent.tsx'
import { ScrollAreaHeader } from '#src/components/core/scroll-area/ScrollAreaHeader.tsx'
import { Helmet } from '#src/components/Helmet.tsx'

export function PageLayout({
  title,
  children,
  actions,
  className,
  contentClassName,
  contentRef,
}: {
  children: ReactNode
  title?: string
  actions?: ReactNode
  className?: string
  contentClassName?: string
  contentRef?: RefObject<HTMLDivElement | null>
}): JSX.Element {
  return (
    <ScrollArea className={className} scrollRestorationId="page-layout">
      <Helmet title={title ?? ''} />
      <div className="flex size-full flex-col">
        {(!!title || !!actions) && (
          <ScrollAreaHeader
            className={cn(
              'flex items-center justify-between gap-4',
              'px-pagex-default lg:px-pagex-lg print:px-px' // When printing, leave room for bordered elements (i.e. Card) that have been bumped out a pixel (so that their content is aligned with non-bordered elements).
            )}
          >
            {title}
            {actions && <div>{actions}</div>}
          </ScrollAreaHeader>
        )}
        <ScrollAreaContent
          className={cn(
            'px-pagex-default lg:px-pagex-lg print:px-px', // When printing, leave room for bordered elements (i.e. Card) that have been bumped out a pixel (so that their content is aligned with non-bordered elements).
            contentClassName
          )}
          ref={contentRef}
        >
          {children}
        </ScrollAreaContent>
      </div>
    </ScrollArea>
  )
}
